export default $axios => ({
  getMessages({ partnerUser, params = {} }) {
    return $axios.get(`/api/partnerUser/${partnerUser}/messages`, {
      params
    });
  },

  getMessageCount({ partnerUser, params = {} }) {
    return $axios.get(
      `/api/partnerUser/${partnerUser}/messages/unreadCount`,
      {
        params
      }
    );
  },

  markMessageRead({ partnerUser, message, params = {} }) {
    return $axios.put(
      `/api/partnerUser/${partnerUser}/messages/${message.id}`,
      null,
      { params }
    );
  }
});
